import { deleteUnifiedSearch } from '@/features/unifiedProfiles/unifiedProfilesSlice';
import { RootState, useAppDispatch } from '@/reducers';
import { makeAccessible } from '@/utils/makeAccessible';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ClearButton } from './ClearButton';

type UnifiedProfileSearchOptionItemProps = {
  item: string;
  setSearchInput: (value: string) => void;
  setOptionsVisibility: (value: boolean) => void;
};

export const UnifiedProfileSearchOptionItem: FC<UnifiedProfileSearchOptionItemProps> = ({ item, setOptionsVisibility, setSearchInput }) => {
  const dispatch = useAppDispatch();
  const lastSearches = useSelector((state: RootState) => state.unifiedProfiles.lastSearches);

  const handleItemClick = useCallback(
    (item: string) => {
      setSearchInput(item);
      setOptionsVisibility(false);
    },
    [dispatch, setOptionsVisibility]
  );

  const handleClearItemClick = useCallback(
    (item: string) => {
      dispatch(deleteUnifiedSearch(item));

      if (lastSearches.length <= 1) {
        setOptionsVisibility(false);
      }
    },
    [dispatch, deleteUnifiedSearch, lastSearches]
  );

  return (
    <li
      key={item}
      {...makeAccessible(() => handleItemClick(`${item}`))}
      className='relative flex items-center gap-2 p-2.5 text-base text-tertiary-600 first-of-type:rounded-t-xl last-of-type:rounded-b-xl hover:bg-primary-hover'
    >
      <p title={item} className='truncate'>
        {item}
      </p>
      <ClearButton onClick={() => handleClearItemClick(item)} />
    </li>
  );
};
